// extracted by mini-css-extract-plugin
export default {"userOrderListContainer":"UserOrderList_userOrderListContainer__by7We","summary":"UserOrderList_summary__TDJ5A"};